module.exports = __webpack_public_path__ + "media/11.45ad3c19.mp4";